export enum CommunicationMethodTypeCode {
  IP_PROTOCOL = "IP_PROTOCOL",
  SERIAL_CONNECTION = "SERIAL_CONNECTION",
}

export const PROTOCOL_FORM_PARAMS = {
  communicationMethodTypeCode: "communicationMethodTypeCode",
  communication: "showAddress",
  ipAddress: "ipAddress",
  port: "port",
  address: "address",
  baudRate: "baudRate",
};
